import Animation from './animation'
import AreaTransformer from '../../line-area/area/transformers/area-bar-transformer'

/*
 * This animation is used to take a single serie that was previously
 * an area and turn it into a bar.
 */
class FromAreaAnimation extends Animation {

  constructor (options) {
    super(options)
    this.ripple = true
  }

  match (serie) {
    let prev = this.previous.allSerieTypes[serie.id]
    return prev && prev.type === 'area'
  }

  animate (serie, entering, selection, merged, exiting) {
    this._insertHidden(entering, serie)

    let previousSerie = this.previous.allSerieTypes[serie.id].serie
      , transformer = new AreaTransformer({
        serie: previousSerie,
        previous: this.previous,
        scalers: this.scalers,
        yScale: this.yScale,
        splitWidth: this.serieScale.bandwidth(),
        areaScale: this.previous.scalers,
        splitScale: d => {
          return this.scalers.x.groupScale(d.rangeId) + this.serieScale(serie._columnIdx)
        },
        styles: {
          area: {
            stroke: previousSerie.selectAll('path.line.data-line').style('stroke'),
            lineStrokeWidth: previousSerie.selectAll('path.line.data-line').style('stroke-width'),
            areaStrokeWidth: previousSerie.selectAll('path.area').style('stroke-width'),
            fill: previousSerie.selectAll('path.area').style('fill'),
            opacity: previousSerie.selectAll('path.area').style('opacity')
          },
          bar: {
            stroke: entering.selectAll('line').style('stroke'),
            areaStrokeWidth: entering.selectAll('line').style('stroke-width'),
            lineStrokeWidth: entering.selectAll('line').style('stroke-width'),
            fill: entering.selectAll('rect').style('fill'),
            opacity: 1
          }
        }
      })

    let splits = transformer.insert(0)

    splits.transition()
          .delay(d => this.timing.delay(d._data))
          .duration(this.timing.duration)
          .tween('transform', function (d) {
            return t => {
              transformer.transform(t, this)
            }
          })
          .end().then(() => {
            // We can now show the real rects
            entering.style('opacity', 1)
            // And remove the splits
            splits.remove()
          }).catch(() => {
            // interrupted transition, ignore
          })


    // Remove the previous serie now that it's transforming into subpaths
    this.previous.allSerieTypes[serie.id].serie.selectAll('.area-group').remove()
  }

}

export default FromAreaAnimation
